import React from 'react';
import ShownPanelsEnum from '../../../../Enums/ShownPanelsEnum';
import ClientPrePaymentService from '../../../../Services/ClientPrePaymentService';
import ShowEntityData from '../../../../Elements/ShowEntityData';
import TpRelatedClientPrePaymentItem from '../../../../Domain/TpRelatedClientPrePaymentItem';
import PrepaymentProjectChangeItem from '../../../../Domain/PrepaymentProjectChangeItem';
import ChangeProjectPanel from '../../../Finance/ClientPrePayment/ChangeProjectPanel';

export default class TpRelatedClientPrePaymentDetailsInfoTab extends React.Component {
  static defaultProps = {
    prepaymentId: 0,
  };

  constructor(props) {
    super(props);

    this.state = {
      PrepaymentId: props.prepaymentId,
      shownPanel: ShownPanelsEnum.None,
      detailItem: {},
    };
    TpRelatedClientPrePaymentItem.clickOnProjectChangeLink = this.clickOnProjectChangeLink.bind(this);
    this.showPanel = this.showPanel.bind(this);
    this.refresh = this.refresh.bind(this);
  }

  clickOnProjectChangeLink(editItem) {
    const detailItem = new PrepaymentProjectChangeItem();
    detailItem.CiCcid = editItem.CiCcid;
    detailItem.ProjectId = editItem.ClCfid;
    detailItem.LineItemId = editItem.ClId;
    this.setState({
      shownPanel: ShownPanelsEnum.EditSubItem,
      detailItem,
    });
  }

  refresh(refresh) {
    if (refresh) {
      window.location.reload();
    } else this.setState({ shownPanel: ShownPanelsEnum.None });
  }

  renderOnePanel = (panelId, content) => (this.state.shownPanel === panelId ? content : null);

  showPanel(panelId) {
    panelId = panelId === this.state.shownPanel ? ShownPanelsEnum.None : panelId;
    this.setState({ shownPanel: panelId });
  }

  renderPanels() {
    return (
      <div>
        {this.renderOnePanel(
          ShownPanelsEnum.EditSubItem,
          <ChangeProjectPanel
            clickOnCancel={() => {
              this.setState({ shownPanel: ShownPanelsEnum.None });
            }}
            baseItem={this.state.detailItem}
          />
        )}
      </div>
    );
  }

  render() {
    return (
      <div>
        <ShowEntityData
          itemId={this.state.PrepaymentId}
          type={TpRelatedClientPrePaymentItem}
          serviceGetByIdFunction={ClientPrePaymentService.GetByPrePaymentId}
        />
        {this.renderPanels()}
      </div>
    );
  }
}
